import "./style.scss";
import $ from "jquery";

function mobileOnlySlider() {
    $('.blok-novice__content').slick({
        infinite: false,
        slidesToShow: 2,
        arrows: false,
        responsive: [
            {
                breakpoint: 680,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
}

if (window.innerWidth < 990) {
    mobileOnlySlider();
}

$(document).ready(function () {
    if (window.innerWidth < 990) {
        mobileOnlySlider();
    }
});
$(window).resize(function () {
    if (window.innerWidth < 990) {
        if (!$('.blok-novice__content').hasClass('slick-initialized')) {
            mobileOnlySlider();
        }

    } else {
        if ($('.blok-novice__content').hasClass('slick-initialized')) {
            $('.blok-novice__content').slick('unslick');
        }
    }
});